import { useEffect, useRef } from "react";
import {
  detectBarcodeFormat,
  isEndOfScan,
  shouldAddToBuffer,
  shouldRestartScan,
} from "../pages/hdi-scanner-page/hdiScannerPageUtils";
import { SymbologyType } from "../types/SymbologyType";

export function useHDIScanner(
  handleScanEvent: (
    scannedBarcode: string,
    symbologyFormat: SymbologyType
  ) => void
) {
  const scanBufferRef = useRef<string>("");
  const lastKeyTimeRef = useRef<number>(0);

  useEffect(() => {
    const SCAN_TIMEOUT = 50;
    const handleKeyPress = (event: KeyboardEvent) => {
      const currentTime = Date.now();

      if (shouldRestartScan(lastKeyTimeRef.current, SCAN_TIMEOUT)) {
        scanBufferRef.current = "";
      }

      lastKeyTimeRef.current = currentTime;

      if (isEndOfScan(event.key)) {
        if (scanBufferRef.current) {
          const symbologyFormat = detectBarcodeFormat(scanBufferRef.current);
          handleScanEvent(scanBufferRef.current, symbologyFormat);
          scanBufferRef.current = "";
        }
      } else if (shouldAddToBuffer(event.key)) {
        scanBufferRef.current += event.key;
      }
    };

    window.addEventListener("keydown", handleKeyPress);
    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [handleScanEvent]);
}
